import React from "react";

export default function ReconcileIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3334 5.62516H16.0093C15.5084 5.62516 15.2579 5.62516 15.0217 5.55365C14.7855 5.48214 14.5771 5.3432 14.1603 5.06533C13.5351 4.64852 12.8219 4.17304 12.4675 4.06576C12.1133 3.9585 11.7375 3.9585 10.9861 3.9585C9.96427 3.9585 9.3056 3.9585 8.84619 4.1488C8.38677 4.3391 8.02549 4.70039 7.30291 5.42296L6.66701 6.05886C6.50417 6.2217 6.42275 6.30313 6.37248 6.38351C6.18615 6.6815 6.2068 7.06437 6.4241 7.34059C6.48272 7.4151 6.57243 7.4873 6.75184 7.63168C7.41499 8.16536 8.37102 8.1121 8.97152 7.50801L10 6.47338H10.8334L15.8334 11.5031C16.2936 11.9661 16.2936 12.7167 15.8334 13.1797C15.3731 13.6427 14.6269 13.6427 14.1667 13.1797L13.75 12.7606M13.75 12.7606L11.25 10.2457M13.75 12.7606C14.2103 13.2236 14.2103 13.9742 13.75 14.4371C13.2898 14.9001 12.5436 14.9001 12.0834 14.4371L11.25 13.5989M11.25 13.5989C11.7103 14.0618 11.7103 14.8125 11.25 15.2755C10.7898 15.7384 10.0436 15.7384 9.58335 15.2755L8.33335 14.018M11.25 13.5989L9.58335 11.9322M8.33335 14.018L7.91669 13.5989M8.33335 14.018C8.7936 14.481 8.7936 15.2316 8.33335 15.6946C7.87312 16.1576 7.12693 16.1576 6.66669 15.6946L4.31366 13.2926C3.83015 12.799 3.58839 12.5522 3.27865 12.422C2.9689 12.2918 2.62342 12.2918 1.93247 12.2918H1.66669"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.3333 12.2915H16.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M7.08335 5.625H1.66669"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </>
  );
}
